<template>
  <div>
      <v-date-picker mode="dateTime"  v-model="range" is-range/>
  </div>
</template>

<script>
export default {
  name: 'calendar',
  data(){
    return {
      range: {
        start: new Date(),
        end: new Date()
      },
      newDate: new Date()
    }
  }
}
</script>

<style>

</style>
